
import { Component, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import RoleRepository, { Roles } from '@/services/Roles';
import HasScope from '@/components/Mixins/HasScope';
import { RoleInterface } from '@/services/Roles/Interfaces';
import { DataTableHeader } from 'vuetify';
import DeleteRoleDialog from '@/components/dialogs/roles/DeleteRoleDialog.vue';
import ScopesRepository from '@/services/Scopes';


@Component({
  mixins: [
    Themeable,
    HasScope,
  ],
  components: {
    DeleteRoleDialog,
  },
  inject: [
    'rolesRepository',
    'scopesRepository',
  ],
})
export default class UserIndex extends Vue {
  private readonly rolesRepository!: RoleRepository;
  private readonly scopesRepository!: ScopesRepository;
  private loading: boolean = true;
  private createRoleScope: string = Roles.USER_ROLES_CREATE;
  private syncRoleScopes: string = Roles.USER_SCOPES_SYNC;
  private search: string = '';
  private roles: RoleInterface[] = [];
  private deleteRoleForDialog: RoleInterface | false = false;
  private deleteRoleDialog: string = '';

  private headers: DataTableHeader[] = [
    { text: 'ID', value: 'id' },
    { text: 'Role', value: 'name' },
    { text: 'Department', value: 'department.name' },
    { text: 'Actions', value: 'actions', sortable: false },
  ];

  private created(): void {
    this.initialize();
  }

  private async initialize(): Promise<void> {
    this.roles = await this.rolesRepository.getAllRoles();
    this.loading = false;
  }

  private editRole(role: RoleInterface): void {
    this.$router.push({ name: 'role_edit', params: { roleId: role.id } });
  }

  private deleteRole(role: RoleInterface): void {
    this.deleteRoleDialog = 'delete-role-dialog';
    this.deleteRoleForDialog = role;
  }

  private createRole(): void {
    this.$router.push({ name: 'role_create' });
  }

  private filterRoles(roleId: string): void {
    this.roles = this.roles.filter((role) => {
      return role.id !== roleId;
    });
  }

  private async syncScopes(): Promise<void> {
    this.loading = true;
    await this.scopesRepository.syncScopes();
    await this.initialize();
  }
}
